import { Flex, Heading, Text, Button, Icon, Box } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { MascotErrorExtended } from 'assets/icons';

const Page404: React.FC<unknown> = () => {
  const { t } = useTranslation(['common', 'components']);
  const navigate = useNavigate();

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      height="100%"
      bg="primary.100"
      textAlign="center"
      position="fixed"
      right="0"
      left="0"
      top="0"
      bottom="0"
      zIndex="11111111111"
      p="6"
    >
      <Box position="relative">
        <Text
          position="absolute"
          bottom="0"
          left="50%"
          transform="translateX(-50%)"
          zIndex="1"
          fontSize="clamp(200px, 38vw, 800px)"
          fontWeight="bold"
          lineHeight="1"
          color="white"
          textShadow="-2px -2px 0 #2A2F5A,
                2px -2px 0 #2A2F5A,
                -2px 2px 0 #2A2F5A,
                2px 2px 0 #2A2F5A,
                -3px 0px 0 #2A2F5A,
                3px 0px 0 #2A2F5A,
                0px -3px 0 #2A2F5A,
                0px 3px 0 #2A2F5A"
        >
          404
        </Text>
        <Icon
          as={MascotErrorExtended}
          height="auto"
          width="auto"
          maxWidth="100%"
          minWidth="550px"
          color="newGray.500"
          zIndex="2"
          position="relative"
        />
      </Box>
      <Box position="relative" zIndex="2">
        <Heading as="h3" fontSize={{ base: 'lg', md: '2xl' }} my={{ base: '4', md: '10' }}>
          {t('common:weCouldNotFindThePage')}
        </Heading>
        <Button w="half" onClick={() => navigate(-1)} colorScheme="secondary">
          {t('common:goBackHome')}
        </Button>
      </Box>
    </Flex>
  );
};

export default Page404;
